import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import {
  SOURCE_KEY,
  CONTENT_KEY,
  DATE_KEY,
  SOURCE_LINK_KEY
} from '../constants/constants';
import { 
  DATA_TABLE_SECTION_I18N_KEYS as MY_I18N_KEYS, 
  DATA_TABLE_SECTION_I18N_PREFIX as MY_I18N_PREFIX 
} from '../constants/i18n/DataTableSectioni18nConstants';

class DataTableSection extends Component {
  static propTypes = {
    cleanedFileData: PropTypes.arrayOf(PropTypes.object).isRequired
  };

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  render() {
    const rowsToDisplay = this.props.cleanedFileData.slice(0, 100);
    let mandatoryColumns = [CONTENT_KEY];
    const optionalColumns = [DATE_KEY, SOURCE_KEY, SOURCE_LINK_KEY]; 
    const headers = mandatoryColumns.concat(
      optionalColumns.filter(col => this.props.cleanedFileData[0] && this.props.cleanedFileData[0][col] !== undefined)
    );

    return (
      <div className="data-table-section">
        <p><em>{this.getI18nText(MY_I18N_KEYS.number_of_rows_displayed)}</em></p>
        <div className='table-wrapper'>
          <table className="data-table">
            <thead>
              <tr>
                <th></th>
                {headers.map((header, _) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rowsToDisplay.map((row, _) => (
                <tr key={row.rowNumber}>
                  <td>{row.rowNumber}</td>
                  {headers.map((header, _) => (
                    <td key={`${row.rowNumber}-${header}`} className="truncate">{row[header]}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };
}

export default DataTableSection;



// WEBPACK FOOTER //
// ./src/features/topics/components/file-upload/DataTableSection.js